import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

const articleImages: Record<string, string> = {
  "article-01": "https://readdy.ai/api/search-image?query=Film%20awards%20ceremony%20scene%2C%20golden%20trophies%20on%20red%20carpet%2C%20warm%20spotlight%20lighting%2C%20elegant%20cinema%20atmosphere%2C%20soft%20bokeh%20background%2C%20sophisticated%20composition%2C%208K%20quality&width=800&height=450&seq=article-01&orientation=landscape",
  "article-02": "https://readdy.ai/api/search-image?query=Shanghai%201990s%20neon%20street%20scene%20at%20night%2C%20warm%20amber%20and%20gold%20lighting%2C%20nostalgic%20urban%20atmosphere%2C%20cinematic%20Wong%20Kar-wai%20aesthetics%2C%20soft%20focus%2C%20elegant%20composition%2C%208K%20quality&width=800&height=450&seq=article-02&orientation=landscape",
  "article-03": "https://readdy.ai/api/search-image?query=Chinese%20animation%20evolution%20concept%20art%2C%20traditional%20ink%20painting%20transitioning%20to%20modern%203D%20rendering%2C%20warm%20golden%20and%20vermillion%20tones%2C%20artistic%20composition%2C%20creative%20visual%20storytelling%2C%208K%20quality&width=800&height=450&seq=article-03&orientation=landscape",
};

export default function ArticlesSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              影视资讯
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              最新影视动态、深度影评与行业观察
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/70"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2 text-xs text-foreground-400">
                  <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-semibold text-foreground-800 text-sm md:text-base leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}